import root from './_root.js';

/** Built-in value references. */
var Symbol = root.Symbol;

export default Symbol;



//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/lodash-es/_Symbol.js
// module id = 49
// module chunks = 0